var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionObsessed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4962 39.6786C62.4962 52.453 52.1405 62.8087 39.3661 62.8087C26.5918 62.8087 16.2361 52.453 16.2361 39.6786C16.2361 26.9043 26.5918 16.5486 39.3661 16.5486C52.1405 16.5486 62.4962 26.9043 62.4962 39.6786Z",
    fill: "#F7E9C5",
    stroke: "#EEC96B",
    strokeWidth: 0.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5029 31.8699C23.3182 32.4553 22.4828 34.6961 22.8972 36.2395C23.7932 39.5765 28.4765 41.642 31.7244 42.8853C33.9135 40.185 36.9331 36.0554 36.0372 32.7186C35.6228 31.1753 33.7768 29.6529 31.5922 30.2383C30.3721 30.5652 29.5869 31.8025 29.0492 32.9222C28.0227 32.2217 26.723 31.543 25.5029 31.8699Z",
    fill: "#EE7661"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9502 31.8699C56.135 32.4553 56.9704 34.6961 56.5559 36.2395C55.6599 39.5765 50.9767 41.642 47.7287 42.8853C45.5396 40.185 42.52 36.0554 43.416 32.7186C43.8303 31.1753 45.6763 29.6529 47.8609 30.2383C49.081 30.5652 49.8662 31.8025 50.4039 32.9222C51.4304 32.2217 52.7301 31.543 53.9502 31.8699Z",
    fill: "#EE7661"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7261 55.7284C45.6114 55.7284 50.5244 51.2064 51.6822 48.0214C51.9091 47.3971 51.3058 46.9031 50.6606 47.0612C48.491 47.5929 43.9176 48.5746 39.7261 48.5746C35.5347 48.5746 30.9612 47.5929 28.7917 47.0612C28.1465 46.9031 27.5432 47.3971 27.7701 48.0214C28.9279 51.2064 33.8409 55.7284 39.7261 55.7284Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionObsessed);
export default __webpack_public_path__ + "static/media/reaction_obsessed.790625cee5ae31410982b2aa70e6345f.svg";
export { ForwardRef as ReactComponent };